export default __webpack_public_path__ + "static/ds_01-377f408fc374c97c7c550f2b1cd23bb8.png";